export default (text) => text.split(/[\s_]/).map(d => (d.charAt(0).toUpperCase() + d.substr(1).toLowerCase())).join('')